import type { AxiosRequestConfig } from "axios"
import type { MaybeRef } from "vue"
import type { ServerResponseV1 } from "@/http"
import type { IWishlistResponse } from "@/types/wishlist.interface"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { v1 } from "@/axios"
import { Wishlist } from "@/models/wishlist"

export interface IGetWishlistOptions {
  includeCurated?: boolean
}

export async function getWishlist(eventVaultId: number, options: IGetWishlistOptions = {}) {
  const requestOptions: AxiosRequestConfig = {}

  if (options.includeCurated)
    requestOptions.params = { includeCurated: options.includeCurated }

  const response = await v1.get<ServerResponseV1<IWishlistResponse>>(
    `/events/${eventVaultId}/wishlist`,
    requestOptions,
  )

  return Wishlist.fromResponse(response.data.data)
}

export const GET_WISHLIST_QUERY_KEY = "getWishlist"

export function useGetWishlist(
  eventVaultId?: MaybeRef<number | undefined>,
  options?: MaybeRef<IGetWishlistOptions | undefined>,
) {
  return useQuery({
    queryKey: [GET_WISHLIST_QUERY_KEY, eventVaultId, options],
    queryFn: () => getWishlist(toValue(eventVaultId)!, toValue(options) ?? {}),
    enabled: !!toValue(eventVaultId),
  })
}
